import Image from "next/image";
import Title from "./Title";
import Typo from "./Typo";
import Button from "./Button";
import Container from "./Container";

export default function CtaBanner({title, body, cta, background}) {
    return (
        <div className="relative text-center bg-black text-white py-16 md:py-24 overflow-hidden">
            {background && (
                <Image src={background}
                       alt=""
                       className="overlay"
                />
            )}
            <Container className="relative flex flex-col gap-10 items-center">
                <Title>{title}</Title>
                <Typo dangerouslySetInnerHTML={{__html: body}} className="max-w-[60ch]"/>
                <Button {...cta} theme="secondary" className="mt-4"/>
            </Container>
        </div>
    )
}
